import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

type PendencyTreatmentStatus = 'company' | 'enterprise'

@Pipe({
    name: 'translatePendencyTreatmentStatus',
    standalone: false
})
@Injectable({ providedIn: 'root' })
export class TranslatePendencyTreatmentStatusPipe implements PipeTransform {
  public constructor(
    private readonly translateService: TranslateService,
  ) {}

  public transform(treatmentStatus: PendencyTreatmentStatus): string {
    if (!treatmentStatus) {
      return ''
    }

    const constraintCase = String(treatmentStatus).toUpperCase()
    return this.translateService.instant(`PIPES.PENDENCY_TREATMENT_STATUS.${constraintCase}`)
  }
}
